import { TableBody, TableCell, TableRow } from "@mui/material";
import React from "react";
import { tableInputStyle } from "../../../../Utils/CommonStyles/muTableStyle";
import Icons from "../../../../Config/Images";
import Strings from "../../../../Config/Strings";

const PageTableBody = ({
  pageDetails,
  onViewpageDetails,
  onEditpageDetails,
  handleShowDeleteModal,
}) => {

  return (
    <TableBody>
      {pageDetails?.length === 0 ? (
        <TableRow>
          <TableCell
            style={{ backgroundColor: "white" }}
            colSpan={5}
            align="center"
          >
            {Strings.NoDataFound}
          </TableCell>
        </TableRow>
      ) : (
        pageDetails?.map((page, index) => (
          <TableRow key={index}>
          <td component="th"style={tableInputStyle}>
            {index + 1}
          </td>
            <TableCell component="th" scope="row" style={tableInputStyle}>
              {page?.page_name}
            </TableCell>
            <TableCell align="right" style={tableInputStyle}>
              <img
                src={Icons.previewIcon}
                style={{
                  height: "20px",
                  width: "20px",
                  cursor: "pointer",
                }}
                onClick={() => onViewpageDetails(page)}
                alt="Preview Icon"
              />
              <img
                src={Icons.editIcon}
                style={{
                  height: "20px",
                  width: "20px",
                  cursor: "pointer",
                  marginLeft: "20px",
                }}
                onClick={() => onEditpageDetails(page)}
                alt="edit Icon"
              />
              <img
                src={Icons.deleteIcon}
                style={{
                  height: "20px",
                  width: "20px",
                  cursor: "pointer",
                  marginLeft: "20px",
                }}
                onClick={() => handleShowDeleteModal(page?.page_id)}
                alt="Delete Icon"
              />
            </TableCell>
          </TableRow>
        ))
      )}
    </TableBody>
  );
};

export default PageTableBody;
